import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';

import { IModalMessages } from '../../../types';

import { styles } from './ClearContent.styles';

export type IClearContentProps = {
  open: boolean;
  onClose(): void;
  messages: IModalMessages;
  handleSubmit(): void;
};

export const ClearContent: React.FC<IClearContentProps> = ({ open, onClose, messages, handleSubmit }) => {
  if (!open) return null;
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm" PaperProps={{ sx: styles.dialogPaper }} aria-labelledby="clear-content-dialog-title">
      <DialogTitle id="clear-content-dialog-title" sx={styles.dialogTitle}>
        {messages.clearContent}
        <IconButton aria-label="close" onClick={onClose} size="small" sx={styles.closeButton}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={styles.dialogContent}>
        <Typography variant="body2">{messages.clearContentText}</Typography>
      </DialogContent>
      <DialogActions sx={styles.dialogActions}>
        <Button variant="outlined" color="secondary" size="small" onClick={onClose}>
          {messages.cancel}
        </Button>
        <Button variant="contained" color="primary" size="small" onClick={handleSubmit}>
          {messages.clear}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
